import { useState, useEffect, useRef } from 'preact/hooks';

// Mobile-friendly info affordance: a small circular "i" that toggles a popover with a plain-
// language explanation. Hover tooltips don't exist on touch, so this works on tap/click and
// keyboard; the native title attr keeps desktop hover working too. Use next to a label or term:
//   <label>Risk per Trade <InfoTip text="How much of the account is risked per trade." /></label>
export function InfoTip({ text, label }: { text: string; label?: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: Event) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <span class="om-infotip" ref={ref}>
      <button
        type="button"
        class="om-infotip-btn"
        title={text}
        aria-label={label ? `${label} — more info` : 'More info'}
        aria-expanded={open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        i
      </button>
      {open && (
        <span class="om-infotip-pop" role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
}
